// 中央氣象署 2026/06/12 烏石漁港潮汐預報（相對當地平均海平面），作為推算基準
const TIDE_BASELINE_DATE = new Date(2026, 5, 12)
const TIDE_BASELINE = {
  highTides: ["03:26", "16:59"],
  lowTides: ["10:21", "22:19"],
}
// 太陰日約 24 小時 50 分，故潮汐每日約晚 50 分鐘出現
const LUNAR_DAY_SHIFT_MINUTES = 50.47

const shiftTime = (time: string, shiftMinutes: number) => {
  const [hour, minute] = time.split(":").map(Number)
  let total = (hour * 60 + minute + shiftMinutes) % 1440
  if (total < 0) total += 1440
  const newHour = Math.floor(total / 60)
  const newMinute = Math.round(total % 60)
  return `${String(newHour).padStart(2, "0")}:${String(newMinute).padStart(2, "0")}`
}

export const getTideData = (date: Date) => {
  const today = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const daysDiff = Math.round((today.getTime() - TIDE_BASELINE_DATE.getTime()) / (24 * 60 * 60 * 1000))
  const shiftMinutes = daysDiff * LUNAR_DAY_SHIFT_MINUTES
  return {
    highTides: TIDE_BASELINE.highTides.map((time) => shiftTime(time, shiftMinutes)).sort(),
    lowTides: TIDE_BASELINE.lowTides.map((time) => shiftTime(time, shiftMinutes)).sort(),
  }
}
